var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgramaSalud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3335 66.6663V49.9997C33.3335 45.5794 35.0894 41.3402 38.215 38.2146C41.3407 35.089 45.5799 33.333 50.0002 33.333H66.6668M33.3335 133.333V150C33.3335 154.42 35.0894 158.659 38.215 161.785C41.3407 164.91 45.5799 166.666 50.0002 166.666H66.6668M133.333 33.333H150C154.42 33.333 158.66 35.089 161.785 38.2146C164.911 41.3402 166.667 45.5794 166.667 49.9997V66.6663M133.333 166.666H150C154.42 166.666 158.66 164.91 161.785 161.785C164.911 158.659 166.667 154.42 166.667 150V133.333M71.6918 80.083C73.2743 78.4704 75.1624 77.1895 77.2457 76.3151C79.329 75.4406 81.5657 74.9903 83.8251 74.9903C86.0845 74.9903 88.3212 75.4406 90.4045 76.3151C92.4878 77.1895 94.3759 78.4704 95.9584 80.083L100 83.333L104.167 80.033C105.748 78.4382 107.631 77.1733 109.705 76.3119C111.779 75.4505 114.004 75.0098 116.25 75.0152C118.496 75.0206 120.718 75.4721 122.788 76.3435C124.858 77.2149 126.735 78.4889 128.308 80.0914C131.53 83.3701 133.334 87.7826 133.334 92.3789C133.334 96.9751 131.53 101.388 128.308 104.666L100 133.333L71.6918 104.666C68.4682 101.387 66.6617 96.973 66.6617 92.3747C66.6617 87.7764 68.4682 83.3621 71.6918 80.083Z",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramaSalud);
export default __webpack_public_path__ + "static/media/ProgramaSalud.b38f43b58d1bca822548389a739f3724.svg";
export { ForwardRef as ReactComponent };